// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608211704/js/" + chunkId + "." + {"44":"bcdb15bc","225":"777e041c","481":"36193147","486":"4f993937","770":"3b38993c"}[chunkId] + ".0.9848801782738115.chunk.js";
};